import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {ListWrapper} from './ListWrapper'

const machineBreadcrumbs: Array<PageLink> = [
  {
    title: 'Gestão de Vendas',
    path: '/sales',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const SalePage = () => {
  return (
    <>
      <PageTitle breadcrumbs={machineBreadcrumbs}>Lista de Vendas</PageTitle>
      <ListWrapper />
    </>
  )
}

export default SalePage
